import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Switch } from './ui/switch';
import { Label } from './ui/label';

export default function AdminWeeklySummarySettings({ api }) {
  const [enabled, setEnabled] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  useEffect(() => {
    let live = true;
    api.get('/admin/weekly-summary-settings').then(({ data }) => {
      if (live) { setEnabled(data.free_users_enabled === true); setLoaded(true); }
    }).catch(() => { if (live) setError('No se pudo cargar la configuración de resúmenes semanales.'); });
    return () => { live = false; };
  }, [api]);
  const save = async () => {
    setSaving(true); setError(''); setMessage('');
    try {
      const { data } = await api.put('/admin/weekly-summary-settings', { free_users_enabled: enabled });
      setEnabled(data.free_users_enabled === true);
      setMessage('Recordatorios de resumen semanal guardados.');
    } catch (e) { setError(e.response?.data?.detail || 'No se pudo guardar la configuración.'); }
    finally { setSaving(false); }
  };
  return <Card className="chart-container">
    <CardHeader><CardTitle>Resúmenes semanales</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center gap-3">
        <Switch id="weekly-free-reminders" checked={enabled} disabled={!loaded || saving}
          onCheckedChange={value => { setEnabled(value); setMessage(''); }} />
        <Label htmlFor="weekly-free-reminders">Recordatorios para usuarios gratuitos</Label>
      </div>
      <p className="text-sm text-slate-500">Incluye a los usuarios gratuitos con acceso vigente en el aviso del lunes a las 9:00, según su zona horaria. Los usuarios con pago vigente conservan sus avisos. Consultar el resumen manualmente sigue disponible.</p>
      <Button onClick={save} disabled={!loaded || saving}>{saving ? 'Guardando…' : 'Guardar recordatorios de resumen semanal'}</Button>
      {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
      {message && <p role="status" className="text-sm text-emerald-600">{message}</p>}
    </CardContent>
  </Card>;
}
